import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';
import { insuranceDetailsContainerStyles, insuranceDetailsOverflowStyles } from './styles';

type PayerDetailsProps = {
  provisions: string[];
  isPrintReport?: boolean;
};

export const Provisions = ({ provisions, isPrintReport = false }: PayerDetailsProps) => {
  const cssStyles = isPrintReport
    ? insuranceDetailsContainerStyles
    : [insuranceDetailsContainerStyles, insuranceDetailsOverflowStyles];

  const { t } = useTranslation('insuranceEligibilityReport');

  if (!provisions || !provisions.length) return null;

  return (
    <div css={cssStyles}>
      <Heading level={3}>{t('Provisions')}</Heading>
      <ul css={{ padding: 'inherit', paddingLeft: theme.spacing(2), paddingTop: theme.spacing(1) }}>
        {provisions.map((value, index) => {
          return (
            <Text as='li' key={(value || '') + index}>
              {value}
            </Text>
          );
        })}
      </ul>
    </div>
  );
};
